import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const SalesSummaryReport: React.FC = () => (
  <ReportPageShell
    reportType="sales-summary"
    title="Sales Summary"
    subtitle="Top-line KPIs for completed sale transactions. Service charge is reported separately and is NOT included in gross sales."
    maxRangeDays={366}
    bullets={[
      'Gross Sales',
      'Net Sales',
      'Tax',
      'Discounts',
      'Refunds',
      'Service Charge',
      'Transaction Count',
      'Average Transaction Value',
    ]}
  />
);

export default SalesSummaryReport;
